import { collection, getDocs, getDoc, doc, setDoc, updateDoc, deleteDoc, query, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';

const COLLECTION_NAME = 'posts';

/**
 * Generate a URL-friendly slug from a string (supports Arabic)
 */
export const generateSlug = (text) => {
  if (!text) return '';
  return text
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\u0621-\u064A0-9-]+/g, '') // Remove all non-word chars except Arabic letters and numbers
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};

/**
 * Get all posts from Firestore
 */
export const getPosts = async () => {
  try {
    const q = query(collection(db, COLLECTION_NAME), orderBy('date', 'desc'));
    const querySnapshot = await getDocs(q);
    const posts = [];
    querySnapshot.forEach((docSnap) => {
      posts.push({ id: docSnap.id, ...docSnap.data() });
    });
    return posts;
  } catch (error) {
    console.error('Error fetching posts:', error);
    return [];
  }
};

/**
 * Save a new post
 */
export const addPost = async (post) => {
  try {
    const posts = await getPosts();
    let slug = post.slug || generateSlug(post.title);
    
    // Ensure slug uniqueness
    let finalSlug = slug;
    let counter = 1;
    while (posts.some(p => p.slug === finalSlug)) {
      finalSlug = `${slug}-${counter}`;
      counter++;
    }

    const newPostId = Date.now().toString();
    const newPost = {
      ...post,
      slug: finalSlug,
      author: post.author || 'أسعار الذهب',
      date: new Date().toISOString(),
    };
    
    await setDoc(doc(db, COLLECTION_NAME, newPostId), newPost);
    return { id: newPostId, ...newPost };
  } catch (error) {
    console.error('Error adding post:', error);
    return null;
  }
};

/**
 * Update an existing post
 */
export const updatePost = async (id, updatedData) => {
  try {
    const posts = await getPosts();
    
    // Process slug update
    let newSlug = updatedData.slug;
    const existingPost = posts.find(p => p.id === id);
    
    if (existingPost) {
      if (!newSlug && updatedData.title) {
        newSlug = generateSlug(updatedData.title);
      } else if (!newSlug) {
        newSlug = existingPost.slug;
      }

      // Check uniqueness if slug changed
      if (newSlug !== existingPost.slug) {
        let finalSlug = newSlug;
        let counter = 1;
        while (posts.some(p => p.slug === finalSlug && p.id !== id)) {
          finalSlug = `${newSlug}-${counter}`;
          counter++;
        }
        newSlug = finalSlug;
      }
      updatedData.slug = newSlug;
    }

    updatedData.lastModified = new Date().toISOString();
    
    await updateDoc(doc(db, COLLECTION_NAME, id), updatedData);
    return true;
  } catch (error) {
    console.error('Error updating post:', error);
    return false;
  }
};


/**
 * Delete a post
 */
export const deletePost = async (id) => {
  try {
    await deleteDoc(doc(db, COLLECTION_NAME, id));
    return true;
  } catch (error) {
    console.error('Error deleting post:', error);
    return false;
  }
};

/**
 * Database auth check
 */
export const login = async (username, password) => {
  try {
    const adminDocRef = doc(db, 'settings', 'admin_credentials');
    const adminDocSnap = await getDoc(adminDocRef);
    
    let validUsername = 'admin';
    let validPassword = 'admin430@';
    
    if (adminDocSnap.exists()) {
      const data = adminDocSnap.data();
      validUsername = data.username || 'admin';
      validPassword = data.password || 'admin430@';
    } else {
      // Auto-initialize the credentials if they don't exist yet
      await setDoc(adminDocRef, {
        username: validUsername,
        password: validPassword
      });
    }
    
    if (username === validUsername && password === validPassword) {
      const token = 'mock_token_' + Date.now();
      localStorage.setItem('admin_token', token);
      return token;
    }
  } catch (error) {
    console.error('Error during login:', error);
  }
  return null;
};

export const logout = () => {
  localStorage.removeItem('admin_token');
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('admin_token');
};
